import { Icon, IconProps } from '@chakra-ui/react';

export const RemoveIcon = (props: IconProps) => (
  <Icon width='24px' height='24px' viewBox='0 0 24 24' fill='none' {...props}>
    <g clipPath='url(#clip0_838_12584)'>
      <path
        d='M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z'
        fill='#E03E52'
      />
    </g>
    <defs>
      <clipPath id='clip0_838_12584'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </Icon>
);
